<div class="bg-white p-3 shadow-3 border-round-sm">
        <div class="rem-text-default flex align-items-center">
          <div class="rem-bg-light p-2 mr-2">
            <i class="pi pi-file-import font-medium"></i>
          </div>
          <div class="text-lg">Import Ingestions</div>
        </div>

        <div class="mt-5">
          <div class="mt-3 px-3 flex align-items-center gap-3">
            <p-floatLabel>
            <p-multiSelect
              [style]="{width: '200px'}"
              id="creditorsImportIngestions"
              [options]="creditors"
              [(ngModel)]="selectedCreditors"
              (ngModelChange)="onChangeCreditor($event)"
              optionLabel="label"
              filterBy="value,label">
              <ng-template let-creditor pTemplate="item">
                <div class="flex align-items-center justify-content-between flex-1">
                  <div>{{ creditor.label }}</div>
                  <div class="ml-2">{{ creditor.value }}</div>
                </div>
              </ng-template>
            </p-multiSelect>
            <label for="creditorsImportIngestions">Select Clients</label>
            </p-floatLabel>
            
            <p-floatLabel>
              <p-calendar 
                    id="fromDateImportIngestions"
                    [(ngModel)]="fromDate"
                    [readonlyInput]="true"      
                    [maxDate]="toDate"             
              />
              <label for="fromDateImportIngestions">From Date</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-calendar 
                    id="toDateImportIngestions"
                    [(ngModel)]="toDate"
                    [readonlyInput]="true"            
                    [minDate]="fromDate"
                    [maxDate]="todaysDate"
              />
              <label for="toDateImportIngestions">To Date</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-multiSelect
                  [style]="{width: '200px'}"
                  id="statusesImportIngestions"
                  [options]="statuses"
                  [(ngModel)]="selectedStatuses"
                  (ngModelChange)="onChangeStatuses($event)"
                  optionLabel="label"
                  optionValue="value"                  
                  />
                <label for="statusesImportIngestions">Status</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-dropdown 
                      [showClear]="true"
                      id="timezonesImportIngestions" 
                      [options]="timezones"
                      [(ngModel)]="selectedTimezone"
                      optionLabel="label" 
                      optionValue="value" 
                      />
                <label for="timezonesImportIngestions">Timezone</label>
            </p-floatLabel>
    
            <remitter-button
              label='Generate'
              icon='send'
              (click)="getGraph()"
            >     
            </remitter-button>
          </div>

          <div class="px-3 mt-4">
            <div class="font-bold text-700 text-lg">File Ingestion History</div>
          </div>

          <div class="px-3 mt-4">
            <div *ngIf="isArrayWithData(rows)">
              <p-table
              [value]="rows"
              class="p-datatable-sm p-datatable-gridlines ingestion-table"
              responsiveLayout="scroll"
              [paginator]="false"
              [scrollable]="true"
              scrollHeight="90vh"
            >


              <ng-template pTemplate="header">
                <tr>
                  <th>Status</th>
                  <th>Creditor</th>
                  <th>File Name</th>
                  <th>Start Time</th>
                  <th class="text-right">Records Processed</th>
                  <th class="text-right">Active Invoices</th>
                  <th class="text-right">Total Contacts</th>
                  <th class="text-right">Voided Invoices</th>
                  <th class="text-right">Voided Rate</th>

                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-r>
                <tr>
                  <td>
                    <div [ngClass]="{'cursor-pointer': r.status !== 'Success'}">
                      <span 
                        [pTooltip]="r.message"
                        class="status-pill" 
                        [ngClass]="r.status">
                        {{ r.status }}
                      </span>
                    </div>
                  </td>

                  <td>{{ r.name }}</td>
                  <td class="filename">{{ r.fileNames }}</td>
                  <td>{{ r.startTime | date:'MMM d, y h:mm a' }}</td>

                  <td class="num">
                    <p-progressBar [value]="getRecordsProgress(r.totalRecords)" color="linear-gradient(90deg, #275e27 0%, #4f9d4f 50%, #9adf9a 100%)" [showValue]="false"></p-progressBar>
                    {{ r.totalRecords | number }}
                  </td>

                  <td class="num">
                    <p-progressBar [value]="getInvoicesProgress(r)" color="linear-gradient(90deg, #174ea6 0%, #4a8fe0 50%, #b9d8ff 100%)"  [showValue]="false"></p-progressBar>
                    {{ r.invoices | number }}
                  </td>

                  <td class="num">
                    <p-progressBar [value]="getContactsProgress(r)" color="linear-gradient(90deg, #0f766e 0%, #5eead4 100%)" [showValue]="false"></p-progressBar>
                    {{ r.contacts | number }}
                  </td>

                  <td class="num red">
                    <p-progressBar [value]="r.voidedRate" color="linear-gradient(90deg, #8b1010 0%, #d64040 50%, #f4b5b5 100%)"  [showValue]="false" styleClass="void-bar"></p-progressBar>
                    {{ r.voided | number }}
                  </td>

                  <td class="num red">
                    {{ r.voidedRate }}%
                  </td>

                </tr>
              </ng-template>

                <ng-template pTemplate="footer">
                <tr class="font-bold bg-gray-100">
                  <td colspan="4">Totals</td>
                  <td class="num" [ngStyle]="{color: '#588358ff'}">{{ totals?.totalRecords | number }}</td>
                  <td class="num" [ngStyle]="{color: '#3B82F6'}">{{ totals?.invoices | number }}</td>
                  <td class="num" [ngStyle]="{color: '#336699'}">{{ totals?.contacts | number }}</td>
                  <td class="num red">{{ totals?.voided | number }}</td>
                  <td class="num red">{{ totals?.voidedRate}}%</td>
                </tr>
                </ng-template>

              </p-table>
            </div>

            <div *ngIf="!isArrayWithData(rows)" class="flex align-items-center justify-content-center h-20rem">
               <div class="font-bold text-red-700">There is no data to display. Please adjust your filter.</div>
             </div>
          </div>

          <div class="flex flex-wrap gap-3 pt-4">
            <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
                    <div>
                      <i class="pi pi-file text-2xl rem-text-default"></i>
                    </div>
                    <div>
                      <div class="font-bold">Records Processed</div>
                      <div class="text-lg rem-text-default font-bold">{{ ( totals?.totalRecords || 0) | number:'1.0-0' }}</div>
                    </div>
            </div>

            <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-receipt text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Active Invoices</div>
                <div class="text-lg rem-text-default font-bold">{{ (totals?.invoices  || 0) | number:'1.0-0' }}</div>
              </div>
            </div>

            <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-id-card text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Contacts Loaded</div>
                <div class="text-lg rem-text-default font-bold">{{ (totals?.contacts || 0) | number:'1.0-0' }}</div>
              </div>
            </div>

            <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-ban text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Voided Rate</div>
                <div class="text-lg rem-text-default font-bold">{{ (totals?.voidedRate || 0) }}%</div>
              </div>
            </div>
          </div>

          <!-- <div class="grid mt-3 pl-3">
            <div class="col-12 lg:col-5">
              <div class="font-bold text-700 text-lg mb-3">Ingestion Summary (Last 3 Days) </div>
              <div echarts [options]="chartOptions" class="ingestion-chart"></div>
            </div>
          </div> -->
        </div>

</div>